import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { AttachmentErrorDialogComponent } from 'src/app/grievance/attachment-error-dialog/attachment-error-dialog.component';
import { CommonFunction } from 'src/app/grievance/common-function';
import { FaqDialogComponent } from 'src/app/grievance/faq-dialog/faq-dialog.component';
import { GrievanceExistDialogComponent } from 'src/app/grievance/grievance-exist-dialog/grievance-exist-dialog.component';
import { ApplicationInterface, Board, Channel, Departments, GrievanceType, Lottery, PaymentInterface } from 'src/app/grievance/interface/common-interface';
import { ProjectConstants } from 'src/app/grievance/project-constants';

import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { GrievanceDialogComponent } from '../../../grievance-dialog/grievance-dialog.component';
import { RegSupportUserService } from './reg-support-user.service';

@Component({
  selector: 'app-reg-support-userr',
  templateUrl: './reg-support-user.component.html',
  styleUrls: ['./reg-support-user.component.scss'],
})
export class RegSupportUserrComponent implements OnInit {
  showFAQ: boolean = false;
  FaqLink: String;

  isSubmitted: boolean = false;
  boardName: any
  createdBy: any
  key: any
  id: any;
  myid: any;
  @ViewChild('attachments') attachments: any;
  @ViewChild('attachments1') attachments1: any;
  @ViewChild('attachments2') attachments2: any;
  isShowClose: boolean = false;
  isShowClose1: boolean = false;
  isShowClose2: boolean = false;

  filefirst: boolean = false;
  fileSecond: boolean = false;
  filethird: boolean = false;
  file: File = null;
  file1: File = null;
  file2: File = null;
  filenm: any;
  filenm1: any;
  filenm2: any;

  fileBase64: any;
  fileBase1_64: any;
  fileBase2_64: any;
  isSubmitDisabled: boolean = false
  protected boards: Board[] = [];
  public boardCtrl: FormControl = new FormControl();
  public boardFilterCtrl: FormControl = new FormControl();
  public filteredboards: ReplaySubject<Board[]> = new ReplaySubject<Board[]>(1);

  protected grievance: GrievanceType[] = [];
  public grievanceCtrl: FormControl = new FormControl();
  public grievanceFilterCtrl: FormControl = new FormControl();
  public filteredGrievance: ReplaySubject<GrievanceType[]> = new ReplaySubject<GrievanceType[]>(1);

  protected channels: Channel[] = [];
  public channelCtrl: FormControl = new FormControl();
  public channelFilterCtrl: FormControl = new FormControl();
  public filteredChannel: ReplaySubject<Channel[]> = new ReplaySubject<Channel[]>(1);

  protected lotteryData: Lottery[] = [];
  public lotteryCtrl: FormControl = new FormControl();
  public lotteryFilterCtrl: FormControl = new FormControl();
  public filteredLottery: ReplaySubject<Lottery[]> = new ReplaySubject<Lottery[]>(1);

  protected departments: Departments[] = [];
  public departmentCtrl: FormControl = new FormControl();
  public departmentFilterCtrl: FormControl = new FormControl();
  public filteredDepartment: ReplaySubject<Departments[]> = new ReplaySubject<Departments[]>(1);

  protected applicationData: ApplicationInterface[] = [];
  public applicationCtrl: FormControl = new FormControl();
  public applicationFilterCtrl: FormControl = new FormControl();
  public filteredApplication: ReplaySubject<ApplicationInterface[]> = new ReplaySubject<ApplicationInterface[]>(1);

  protected paymentData: PaymentInterface[] = [];
  public paymentCtrl: FormControl = new FormControl();
  public paymentFilterCtrl: FormControl = new FormControl();
  public filteredPayment: ReplaySubject<PaymentInterface[]> = new ReplaySubject<PaymentInterface[]>(1);

  fileWarningMsg1 = ProjectConstants.uiUploadMax3FilesMsg
  fileWarningMsg2 = ProjectConstants.uiFileExtensionMsg
  fileWarningMsg3 = ProjectConstants.uiFileSizeMsg
  protected _onDestroy = new Subject<void>();
  progressSpinnerDialog: any = null;

  firstFormGroup = this._formBuilder.group({
    boardCtrl: ['', [Validators.required]],
    grievanceCtrl: ['', [Validators.required]],
    subjectCtrl: ['', [Validators.required]],
    channelCtrl: ['', [Validators.required]],
    lotteryCtrl: [''],
    applicationCtrl: [''],
    // paymentCtrl: [''],
    departmentCtrl: [''],
    mobileCtrl: [{ value: null, disabled: true }],
    nameCtrl: [{ value: null, disabled: true }],
    emailCtrl: [{ value: null, disabled: true }],
    addressCtrl: [{ value: null, disabled: true }],
    remarkCtrl: ['', [Validators.required]]
  })

  constructor(public _formBuilder: FormBuilder,
    public toastController: ToastController,
    public dialog: MatDialog,
    public router: Router,
    private commonFunction: CommonFunction,
    public activatedRoute: ActivatedRoute,
    public regSupportuserService: RegSupportUserService,
  ) { }

  async ngOnInit() {
    this.showFile()
    this.id = this.activatedRoute.snapshot.paramMap.get('myid');

    //load lottory user against lottory reg id
    const data = {
      'lotteryRegiId': this.id
    }
    this.displayProgressSpinner();
    const response: any = await this.regSupportuserService.loadRegUserById(data);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        this.firstFormGroup.setValue({
          boardCtrl: "",
          grievanceCtrl: "",
          subjectCtrl: "",
          lotteryCtrl: "",
          // mobileCtrl: this.mask_mobile(response.rgPhoneNo),
          mobileCtrl: response.rgPhoneNo,

          nameCtrl: response.rgName,
          emailCtrl: response.rgEmailid,
          addressCtrl: response.rgAddress,
          remarkCtrl: "",
          channelCtrl: "",
          applicationCtrl: '',
          // paymentCtrl: '',
          departmentCtrl: '',
        })
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
    }
    this.loadPredata();
  }

  mask_mobile(number) {
    let mask = ''
    for (let i = 1; i <= number.length - 4; i++) {
      mask += '*'
    }
    number = mask + number.slice(6, 10);
    return number
  }


  // mask_email(mail) {
  //   const [name, domain] = mail.split('@');
  //   const { length: len } = name;
  //   const maskedName = name[0] + '****' + name[len - 1];
  //   const maskedEmail = maskedName + '@' + domain;
  //   return maskedEmail
  // }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  //load board
  async loadPredata() {
    this.displayProgressSpinner();
    const response: any = await this.regSupportuserService.loadBoard();
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.boards = response
        this.boardCtrl.setValue(this.boards[10]);
        this.filteredboards.next(this.boards.slice());
        this.boardFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterboards();
          });
      } else if (response[0].status == ProjectConstants.responseStatusFailure) {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
    }
    //

    //load channel
    this.displayProgressSpinner();
    const reschannel: any = await this.regSupportuserService.loadChannel();
    this.progressSpinnerDialog.close()
    if (reschannel != null && !reschannel.error) {
      if (reschannel[0].status == ProjectConstants.responseStatusSuccess) {
        this.channels = reschannel
        this.channelCtrl.setValue(this.channels[10]);
        this.filteredChannel.next(this.channels.slice());
        this.channelFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterChannels();
          });
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
    }
    //
  }

  // filter boards
  protected filterboards() {
    if (!this.boards) {
      return;
    }
    let search = this.boardFilterCtrl.value;
    if (!search) {
      this.filteredboards.next(this.boards.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredboards.next(this.boards.filter(
      item => item.boardName.toLowerCase().indexOf(search) > -1)
    )
  }
  //

  //filter departments
  protected filterChannels() {
    if (!this.channels) {
      return;
    }
    let search = this.channelFilterCtrl.value;
    if (!search) {
      this.filteredChannel.next(this.channels.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredChannel.next(
      this.channels.filter(channels => channels.channelName.toLowerCase().indexOf(search) > -1)
    );
  }
  //

  // select board dependant on grievance type
  async selectBoard(boards: any) {
    this.showFAQ = false;
    this.displayProgressSpinner();
    const response: any = await this.regSupportuserService.loadDepartment(boards);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.departments = response;
        this.departmentCtrl.setValue(this.departments[10]);
        this.filteredDepartment.next(this.departments.slice());
        this.departmentFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtereDepartment();
          })
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
    }

    this.displayProgressSpinner();
    const response1: any = await this.regSupportuserService.loadLottery(boards);
    this.progressSpinnerDialog.close()
    if (response1 != null && !response1.error) {
      if (response1.length != 0) {
        if (response1[0].status == ProjectConstants.responseStatusSuccess) {
          this.lotteryData = response1;
          this.lotteryCtrl.setValue(this.lotteryData[10]);
          this.filteredLottery.next(this.lotteryData.slice());
          this.lotteryFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
              this.filtereLottery();
            })
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
        }
      } else {
        this.lotteryData = [];
        this.lotteryCtrl.setValue(this.lotteryData[10]);
        this.filteredLottery.next(this.lotteryData.slice());
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
    }
  }
  //

  async selectDepartment(deptId) {

    this.displayProgressSpinner();
    const response: any = await this.regSupportuserService.loadGrievance(deptId);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.length != 0) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          this.grievance = response;
          this.grievanceCtrl.setValue(this.grievance[10]);
          this.filteredGrievance.next(this.grievance.slice());
          this.grievanceFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
              this.filtereGrievances();
            })
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
        }
      } else {
        this.grievance = [];
        this.grievanceCtrl.setValue(this.grievance[10]);
        this.filteredGrievance.next(this.grievance.slice());
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
    }
  }


  // async selectApplication(applicationId: any) {

  //   this.displayProgressSpinner();
  //   const response: any = await this.regSupportuserService.loadPayment(applicationId);
  //   this.progressSpinnerDialog.close()

  //   if (response != null && !response.error) {
  //     if (response.length != 0) {
  //       if (response[0].status == ProjectConstants.responseStatusSuccess) {
  //         this.paymentData = response;
  //         this.paymentCtrl.setValue(this.paymentData[10]);
  //         this.filteredPayment.next(this.paymentData.slice());
  //         this.paymentFilterCtrl.valueChanges
  //           .pipe(takeUntil(this._onDestroy))
  //           .subscribe(() => {
  //             this.filterePayment();
  //           })
  //       } else {
  //         this.errorToast()
  //       }
  //     } else {
  //       this.paymentData = [];
  //       this.paymentCtrl.setValue(this.paymentData[10]);
  //       this.filteredPayment.next(this.paymentData.slice());
  //     }
  //   } else {
  //     this.errorToast()

  //   }
  // }


  filterePayment() {
    if (!this.paymentData) {
      return;
    }
    let search = this.paymentFilterCtrl.value;
    if (!search) {
      this.filteredPayment.next(this.paymentData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredPayment.next(
      this.paymentData.filter(paymentData => paymentData.paymentAmount.toLowerCase().indexOf(search) > -1)
    );
  }

  //lottery filter
  protected filtereLottery() {
    if (!this.lotteryData) {
      return;
    }
    let search = this.lotteryFilterCtrl.value;
    if (!search) {
      this.filteredLottery.next(this.lotteryData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredLottery.next(
      this.lotteryData.filter(lotteryData => lotteryData.lotteryName.toLowerCase().indexOf(search) > -1)
    );
  }
  //

  //grievance type filter
  protected filtereGrievances() {
    if (!this.grievance) {
      return;
    }
    let search = this.grievanceFilterCtrl.value;
    if (!search) {
      this.filteredGrievance.next(this.grievance.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredGrievance.next(
      this.grievance.filter(grievance => grievance.gtGrievanceType.toLowerCase().indexOf(search) > -1)
    );
  }
  //

  filtereDepartment() {
    if (!this.departments) {
      return;
    }
    let search = this.departmentFilterCtrl.value;
    if (!search) {
      this.filteredDepartment.next(this.departments.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDepartment.next(
      this.departments.filter(department => department.departmentName.toLowerCase().indexOf(search) > -1)
    );
  }

  // remove upload
  removeAttachment() {
    if (this.file1 != null) {
      this.file = this.file1
      this.filenm = this.filenm1
      this.fileBase64 = this.fileBase1_64
      if (this.file2 != null) {
        this.file1 = this.file2
        this.filenm1 = this.filenm2
        this.fileBase1_64 = this.fileBase2_64
        this.isShowClose2 = false;
        this.file2 = null
        this.fileBase2_64 = null
        this.filenm2 = null
      } else {
        this.attachments.nativeElement.value = '';
        this.file1 = null
        this.fileBase1_64 = null
        this.filenm1 = null
        this.isShowClose1 = false;
      }
    } else {
      this.attachments.nativeElement.value = '';
      this.file = null
      this.fileBase64 = null
      this.filenm = null
      this.isShowClose = false;
    }
    this.showFile()
  }
  //

  // remove upload
  removeAttachment1() {
    if (this.file2 != null) {
      this.file1 = this.file2
      this.file2 = null
      this.fileBase1_64 = this.fileBase2_64
      this.fileBase2_64 = null
      this.filenm1 = this.filenm2
      this.filenm2 = null
      this.isShowClose2 = false;
    } else {
      this.attachments1.nativeElement.value = '';
      this.isShowClose1 = false;
      this.file1 = null
      this.filenm1 = null
      this.fileBase1_64 = null
    }
    this.showFile()
  }
  //

  // remove upload
  removeAttachment2() {
    this.attachments2.nativeElement.value = '';
    this.isShowClose2 = false;
    this.file2 = null
    this.filenm2 = null
    this.fileBase2_64 = null
    this.showFile()
  }
  //

  //file upload 1
  onChange(event) {
    this.file = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':
        if (size <= ProjectConstants.maxFileSize) {
          if (this.file == null) {
            this.isShowClose = false;
            this.filenm = ""
          } else {
            this.filenm = this.file.name
            this.isShowClose = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(this.file);
          }
        } else {
          this.file = null;
          this.isShowClose = false;
          this.filenm = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue },
          });
          event.target.value = "";
        }

        break;
      default:
        this.file = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse },
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file == null) {
            this.isShowClose = false;
          } else {
            this.isShowClose = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(this.file);
          }
        });
    }
  }
  //

  //file upload 2
  onChange1(event) {
    this.file1 = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':

        if (size <= ProjectConstants.maxFileSize) {
          if (this.file1 == null) {
            this.isShowClose1 = false;
            this.filenm1 = ""
          } else {
            this.filenm1 = this.file1.name
            this.isShowClose1 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(this.file1);
          }
        } else {
          this.file1 = null;
          this.isShowClose1 = false;
          this.filenm1 = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue },
          });
          event.target.value = "";
        }


        break;
      default:
        this.file1 = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse },
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file1 == null) {
            this.isShowClose1 = false;
          } else {
            this.isShowClose1 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(this.file1);
          }
        });
    }
  }
  //

  //file upload
  onChange2(event) {
    this.file2 = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':
        if (size <= ProjectConstants.maxFileSize) {
          if (this.file2 == null) {
            this.isShowClose2 = false;
            this.filenm2 = ""
          } else {
            this.filenm2 = this.file2.name
            this.isShowClose2 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(this.file2);
          }
        } else {
          this.file2 = null;
          this.isShowClose2 = false;
          this.filenm2 = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue },
          });
          event.target.value = "";
        }

        break;
      default:
        this.file2 = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse },
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file2 == null) {
            this.isShowClose2 = false;
          } else {
            this.isShowClose2 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(this.file2);
          }
        });
    }
  }

  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase64 = btoa(binaryString);
  }
  _handleReaderLoaded1(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase1_64 = btoa(binaryString);
  }

  _handleReaderLoaded2(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase2_64 = btoa(binaryString);
  }

  async selectLottery(lotteryId: any) {
    this.displayProgressSpinner();
    const response: any = await this.regSupportuserService.loadApplications(lotteryId, this.id);
    this.progressSpinnerDialog.close()

    if (response != null && !response.error) {
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.applicationData = response;
        this.applicationCtrl.setValue(this.applicationData[10]);
        this.filteredApplication.next(this.applicationData.slice());
        this.applicationFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtereApplication();
          })
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
    }
  }

  filtereApplication() {
    if (!this.applicationData) {
      return;
    }
    let search = this.applicationFilterCtrl.value;
    if (!search) {
      this.filteredApplication.next(this.applicationData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredApplication.next(
      this.applicationData.filter(applicationData => applicationData.applicationNo.toLowerCase().indexOf(search) > -1)
    );
  }


  showFile() {
    if (this.file == null && this.file1 == null && this.file2 == null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 == null && this.file2 != null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 != null && this.file2 == null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 != null && this.file2 != null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 == null && this.file2 == null) {
      this.filefirst = false;
      this.fileSecond = true;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 == null && this.file2 != null) {
      this.filefirst = false;
      this.fileSecond = true;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 != null && this.file2 == null) {
      this.filefirst = false;
      this.fileSecond = false;
      this.filethird = true;
    }
    else if (this.file != null && this.file1 != null && this.file2 != null) {
      this.filefirst = false;
      this.fileSecond = false;
      this.filethird = false;
    }
  }

  //submit button
  async submitForm(): Promise<void> {
    this.isSubmitted = true;
    if (this.firstFormGroup.valid) {
      const checkDuplicateData = {
        'gtId': this.firstFormGroup.controls['grievanceCtrl'].value,
        'userID': this.id
      }
      this.displayProgressSpinner();
      const responseDuplicate: any = await this.regSupportuserService.isCheckDeuplicate(checkDuplicateData)
      this.progressSpinnerDialog.close()
      if (responseDuplicate != null && !responseDuplicate.error) {
        if (responseDuplicate.status == ProjectConstants.responseStatusSuccess) {
          if (responseDuplicate.message == ProjectConstants.responseGriExist) {
            const dialogRef = this.dialog.open(GrievanceExistDialogComponent, {
              width: 'fit-content',
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe(async result => {
              var returnval = result;
              if (returnval == ProjectConstants.noMsg) {
                this.router.navigate(['secure/search-user-list'])
              } else {
                this.callRest()
              }
            });
          } else {
            this.callRest()
          }
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
      }
    }
    else {
      this.isSubmitDisabled = false
    }
  }
  //

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  async callRest() {
    var lotteryVal
    if (this.firstFormGroup.controls['lotteryCtrl'].value == "") {
      lotteryVal = null
    } else {
      lotteryVal = this.firstFormGroup.controls['lotteryCtrl'].value
    }
    var application
    if (this.firstFormGroup.controls['applicationCtrl'].value == "") {
      application = null
    } else {
      application = this.firstFormGroup.controls['applicationCtrl'].value
    }
    if (this.filenm != null) {
      var file1_extension = '.' + this.filenm.split('.')[this.filenm.split('.').length - 1]
    }
    if (this.filenm1 != null) {
      var file2_extension = '.' + this.filenm1.split('.')[this.filenm1.split('.').length - 1]
    }
    if (this.filenm2 != null) {
      var file3_extension = '.' + this.filenm2.split('.')[this.filenm2.split('.').length - 1]
    }

    const data = {
      'fkChid': this.firstFormGroup.controls['channelCtrl'].value,
      'depId': this.firstFormGroup.controls['departmentCtrl'].value,
      'fkLotteryUserRegid': this.id,
      'fkLotteryid': lotteryVal,
      'fkAppliid': application,
      // 'fkPaymentid': payment,
      'fkBdid': this.firstFormGroup.controls['boardCtrl'].value,
      'fkGtid': this.firstFormGroup.controls['grievanceCtrl'].value,
      'usGriDetails': this.firstFormGroup.controls['remarkCtrl'].value,
      'usGriSubject': this.firstFormGroup.controls['subjectCtrl'].value,
      'file1': this.fileBase64,
      'file1Ext': file1_extension,
      'file2': this.fileBase1_64,
      'file2Ext': file2_extension,
      'file3': this.fileBase2_64,
      'file3Ext': file3_extension,
      'file1Name': this.filenm,
      'file2Name': this.filenm1,
      'file3Name': this.filenm2
    };
    this.displayProgressSpinner();
    const response: any = await this.regSupportuserService.submitGrievance(data);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        const dialogRef = this.dialog.open(GrievanceDialogComponent, {
          width: 'fit-content',
          data: { id: response.pkUsgrid }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.router.navigate(['secure/search-user-list'])
        });
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/search-user-list")
    }
  }

  grievanceTypeId: any
  async getFaqLink(grievanceTypeId: any) {
    const responce = await this.regSupportuserService.loadFaqLink(grievanceTypeId)
    this.grievanceTypeId = grievanceTypeId
    this.FaqLink = responce;
    this.showFAQ = true;
  }

  openWindow() {
    const dialogRef = this.dialog.open(FaqDialogComponent, {
      width: 'fit-content',
      disableClose: false,
      data: { id: this.grievanceTypeId }
    });
  }
}



